import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CharacterSummary } from '../../../shared/character-search';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-character-card',
	templateUrl: './character-card.component.html',
	styleUrl: './character-card.component.css',
	imports: [NgClass, RouterLink],
})
export class CharacterCardComponent {
	@Input() character!: CharacterSummary;
	@Input() raceMap!: Map<string, string>;

	@Input() isMyCharacterPage = false;
	@Input() isMyPnjPage = false;
	@Input() isAdmin = false;

	@Output() delete = new EventEmitter<CharacterSummary>();

	onDelete() {
		this.delete.emit(this.character);
	}
}
